import { render, staticRenderFns } from "./ProjectUploadVexModal.vue?vue&type=template&id=0b8ec87d&"
import script from "./ProjectUploadVexModal.vue?vue&type=script&lang=js&"
export * from "./ProjectUploadVexModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports